import { useMutation } from '@tanstack/react-query'
import { cancelTurn } from '../../../data/statsAssistant'
import { UserFriendlyError } from '../../../model/Error'

export const useCancelTurn = () =>
  useMutation({
    mutationFn: async (conversationUlid: string) => {
      const { ok } = await cancelTurn(conversationUlid)
      if (!ok) {
        throw new UserFriendlyError('error', 'Impossible d’arrêter l’analyse')
      }
    },
  })
